// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1sqQy","content":"ManualTimeModal_content__2D8Tk"};